import { ChangeDetectionStrategy, Component, Injector, ViewEncapsulation } from '@angular/core';
import { LinkService } from '@core/services/link.service';
import { BaseComponent } from '../base.component';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatButton, AsyncPipe, TranslatePipe]
})
export class FooterComponent extends BaseComponent {
  year: number;

  constructor(private readonly injector: Injector, private readonly linkService: LinkService) {
    super(injector);
    this.year = new Date().getUTCFullYear() % 100;
  }

  feedback() {
    this.linkService.feedback();
  }
}
